Application.Summary.Email = {
    ui: {
        container: '.js-summary-email',
        form: '.js-summary-email__form',
        cookie: '.js-cookie-link',
        email: '.js-summary-email__email',
        submit: '.js-summary-email__submit',
        success: '.js-summary-email__success',
        pdf: '.js-summary-email__pdf',
    },
    summary: this,
    ready: function (summary) {

        var self = this;

        this.summary = summary;

        if (!$(this.ui.form).length){
            return;
        }

        // change input
        $(this.ui.email).on('change keydown', function(e){
            self.validate();
        });
        this.validate();

        // submit
        $(this.ui.form).submit(function(e){
            e.preventDefault();
            self.submit();
        });

    },
    submit: function () {

        var self = this;

        if (!this.validate()){
            return;
        }

        var url = $(this.ui.form).attr('action');
        var email = $(this.ui.email).val();

        // loader
        this.summary.showLoader();

        $.post(url, {
            email: email
        }, function(data){
            if (data.result){
                self.success(data.pdf);
                self.summary.hideLoader();
            }
        }, 'json');


    },
    validate: function () {

        var valid = true;

        var email = $(this.ui.email).val();
        if (valid = this.validateEmail(email)){
            $(this.ui.submit).removeClass('disabled');
        }else{
            $(this.ui.submit).addClass('disabled');
        }

        return valid;

    },
    validateEmail: function(email){

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());

    },
    success: function(pdf){

        $(this.ui.form).removeClass('active');
        $(this.ui.cookie).removeClass('active');
        $(this.ui.success).addClass('active');
        $(this.ui.pdf).attr('href', pdf);

    }
};